import { render, staticRenderFns } from "./NotificationUpdateAvailable.vue?vue&type=template&id=49813ca9"
import script from "./NotificationUpdateAvailable.vue?vue&type=script&lang=js"
export * from "./NotificationUpdateAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports